import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { cva } from 'class-variance-authority';

// Field error hangs under the control out of flow: the cell keeps its height, so neither the label nor a centred
// row stack moves when the error shows. One line only: a long error is clipped, never over the next row.
const formRowVariants = cva(
  'grid max-sm:grid-cols-1 max-sm:gap-1.5 *:has-data-[slot=field-error]:relative **:data-[slot=field-error]:absolute **:data-[slot=field-error]:inset-x-0 **:data-[slot=field-error]:top-full **:data-[slot=field-error]:mt-0.5 **:data-[slot=field-error]:line-clamp-1',
  {
    variants: {
      align: { center: 'items-center', start: 'items-start' },
      // `lg` — шаг мастера: колонка подписи шире, воздух до контрола больше.
      size: { md: 'grid-cols-[var(--layout-panel-list)] gap-4', lg: 'grid-cols-[var(--layout-panel-list-lg)] gap-5' },
      // `container` — узкая боковая панель: подпись встаёт над контролом и на десктопе, когда сама строка уже 24rem.
      stack: { none: '', container: '@container @max-sm:*:col-span-full' },
    },
    defaultVariants: { align: 'center', size: 'md', stack: 'none' },
  },
);

const formRowLabelVariants = cva('text-sm text-c2', {
  variants: {
    align: { center: '', start: 'pt-2.5 max-sm:pt-0' },
  },
  defaultVariants: { align: 'center' },
});

/** Строка формы «подпись слева — контрол справа»: на десктопе две колонки, на телефоне подпись встаёт над контролом. */
@Component({
  selector: 'app-form-row',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class]': 'cls()',
  },
  template: `
    <span [class]="labelCls()">{{ label() }}</span>
    <ng-content />
  `,
})
export class FormRowComponent {
  readonly label = input.required<string>();
  /** «start» — для высокого контрола: подпись держится первой строки, а отступ выравнивает её по ней. */
  readonly align = input<'center' | 'start'>('center');
  readonly size = input<'md' | 'lg'>('md');
  readonly stack = input<'none' | 'container'>('none');

  protected readonly cls = computed(() => formRowVariants({ align: this.align(), size: this.size(), stack: this.stack() }));
  protected readonly labelCls = computed(() => formRowLabelVariants({ align: this.align() }));
}
